<figure style="background-image: url('assets/images/maintenance.png')" alt="">
    <h3>{{message}}</h3>
</figure>